import { render, staticRenderFns } from "./DetailedGraphsCollapse.vue?vue&type=template&id=2da77e2c&"
import script from "./DetailedGraphsCollapse.vue?vue&type=script&lang=js&"
export * from "./DetailedGraphsCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports